import { render } from "./LastSequences.vue?vue&type=template&id=37a04ce2"
import script from "./LastSequences.vue?vue&type=script&lang=js"
export * from "./LastSequences.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__